let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3nXj2")).then(() => parcelRequire('v9BTs'));